var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{attrs:{"type":"primary","disable-transitions":""}},[_vm._v("\n  "+_vm._s(_vm.$t(("offer." + _vm.tag)))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }